import { ref } from "vue";
import { ApolloError, gql } from "@apollo/client/core";
import { useMutation } from "@vue/apollo-composable";

const SEND_TEST_EMAIL_MUTATION = gql`
  mutation testInvitation($input: TestInvitationInput!) {
    testInvitation(input: $input) {
      successMessage
      error
    }
  }
`;

export function useTestInvitation() {
  const sendTestEmailLoading = ref(false);
  const finalMessage = ref("");
  const finalError = ref("");

  const {
    mutate: sendTestEmailMutation,
    onDone,
    onError,
  } = useMutation(SEND_TEST_EMAIL_MUTATION);

  const sendTestEmail = ({
    programId,
    message,
    userEmail,
  }: {
    programId: string;
    message?: string;
    userEmail: string;
  }) => {
    finalError.value = "";
    finalMessage.value = "";
    if (!userEmail) {
      finalError.value = "Your email is not available.";
      return;
    }
    sendTestEmailLoading.value = true;
    sendTestEmailMutation({
      input: {
        inviteParams: {
          emails: [userEmail],
          programId,
          message: message || undefined,
        },
      },
    });
  };

  const onTestDoneHandler = (response: any) => {
    sendTestEmailLoading.value = false;
    if (response) {
      finalError.value = "";
      finalMessage.value = "";
      const data = response.data.testInvitation;
      if (data?.error?.length > 0) {
        finalError.value = "Email not sent. Please try again later.";
      } else {
        finalMessage.value =
          data.successMessage || "Test email sent successfully!";
      }
    }
  };
  const onTestErrorHandler = (error: ApolloError) => {
    sendTestEmailLoading.value = false;
    finalError.value = "Something went wrong. Please try again later.";
  };
  onDone(onTestDoneHandler);
  onError(onTestErrorHandler);

  return {
    sendTestEmail,
    sendTestEmailLoading,
    finalMessage,
    finalError,
  };
}
